import { useNavigate } from 'react-router-dom';

export const useNavigateToSection = () => {
  const navigate = useNavigate();

  const navigateToSection = (sectionId) => {
    if (window.location.pathname === '/') {
        const element = document.getElementById(sectionId);
        if(element) {
          const yOffset = -70; // Adjust this value based on your navbar height
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        } else {
            console.error(`Element with id ${sectionId} not found`);
        }
    } else {
      navigate(`/#${sectionId}`);
    }
  };

  return navigateToSection;
};
